import React from 'react';
import {injectIntl, defineMessages} from 'react-intl';
import Relay from 'react-relay';
import PropTypes from 'prop-types';
import ApplicationsBox from '../web/applicationsBox.react';
import AppPanel from '../fw/AppPanel.react';
import ScenarioListPure from './ScenarioListPure.react';

import '../layout.scss';
import '../web/scenarios.scss';

const messages = defineMessages({
	title: {id: 'scenarioList.title', 'defaultMessage': 'Scenarios'},
	missingScenariosSubject: {id: 'webScenarios.missingScenariosSubject', 'defaultMessage': 'Missing scenarios for {applications} combination'},
	whatThisScenarioShouldDo: {id: 'webScenarios.whatThisScenarioShouldDo2', 'defaultMessage': 'What should this scenario do?'},
});

class ScenarioList extends React.Component {
	static propTypes = {
		intl: PropTypes.object.isRequired,
		relay: PropTypes.object,
		user: PropTypes.object
	}

	render() {
		return (
			<AppPanel className="ScenarioListPanel" title={this.props.intl.formatMessage(messages.title)}>
				<div className="scenarioSelector">
					<div className="applicationFilter">
						<ApplicationsBox applications={this.props.user.publicChannelDefs.edges}/>
					</div>
					<div className="content-wrapper"  id="scenarioListPure" >
						<ScenarioListPure user={this.props.user} />
					</div>
				</div>
			</AppPanel>
		);
	}
}

export default Relay.createContainer(injectIntl(ScenarioList), {
	initialVariables: {
	},
    prepareVariables (variables) {

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
				publicChannelDefs(first: 1000) {
					edges {
						node {
							id,
							realId,
							name,
							icon,
							tags,
							urlFragment,
						}
					},
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
				},
				${ScenarioListPure.getFragment('user')}
			}
        `,
    },
});
